import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './FiltersDrawer.styles';
import { AdOrder } from '@/api/types/ads.types';

interface CatalogueDrawerProps {
  sort: AdOrder;
  setSort: React.Dispatch<React.SetStateAction<AdOrder>>;
}

export const FiltersDrawerSortItems: React.FC<CatalogueDrawerProps> = ({
  sort,
  setSort,
}) => {
  const { t } = useTranslation();

  const sortItems = Object.values(AdOrder).filter(el => el !== AdOrder.Random);

  return (
    <S.FieldWithTitleWrapper>
      <S.FieldTitle>{t('common.sorting')}</S.FieldTitle>
      <S.ChipsContainer>
        {sortItems.map(el => {
          return (
            <S.Chip
              id={
                el !== AdOrder.DateDesc
                  ? `order_${el.toLowerCase()}`
                  : undefined
              }
              key={el}
              dataTestId="sort-item"
              appearance={sort === el ? 'primary' : 'gray'}
              onClick={() => setSort(el)}
            >
              {t(`common.${el.toLowerCase()}`)}
            </S.Chip>
          );
        })}
      </S.ChipsContainer>
    </S.FieldWithTitleWrapper>
  );
};
